/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'

// components
import { Autocomplete, TextField, CircularProgress, IconButton } from '@mui/material';
import useApplications from './hooks/useApplications';
import { getAdminApplications, isSuperAdmin } from '../../../../../../helpers/user';
import SearchIcon from '../../../../../../assets/Search.svg'
import CloseIcon from '@mui/icons-material/Close'

// hooks
import usePreviousSearchText from '../../../../../../hooks/usePreviousSearchText';

const GroupsSearch = ({ getGroups }) => {
  const isSuperAdminUser = isSuperAdmin();
  const [searchText, setSearchText] = useState('');
  const { previousSearchText, setPreviousSearchText } = usePreviousSearchText(searchText);
  const [selectedApplication, setSelectedApplication] = useState('');
  const { applications, areApplicationsLoading, getApplications } =
    useApplications(searchText);
  const adminApplications = getAdminApplications();
  const { t } = useTranslation()

  useEffect(() => {
    if (selectedApplication) {
        getGroups(`${selectedApplication} -`);
    }
  }, [selectedApplication])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && isSuperAdminUser && searchText !== previousSearchText) {
      setPreviousSearchText(searchText)
        getApplications();
      }
  }

  const handleInputChange = (event, newInputValue) => {
    setSearchText(newInputValue);
  }
  const options = isSuperAdminUser ? applications : adminApplications;

  useEffect(() => {
    if (!isSuperAdminUser && options?.length == 1) {
      const application = options[0];
      setSelectedApplication(application);
    }
  }, [])

  return (
    <div style={{ marginTop: '10px', marginLeft: '12px', marginRight: '23px' }}>
      <Autocomplete
        disablePortal
        id="application"
        loading={areApplicationsLoading}
        value={selectedApplication || ''}
        options={options}
        required
        onChange={(e, v) => {
          setSelectedApplication(v);
        }}
        onKeyDown={handleKeyDown}
        inputValue={searchText}
        onInputChange={handleInputChange}
        forcePopupIcon={false}
        disableClearable
        renderInput={(params) => (
          <TextField
          {...params}
            placeholder={t('group-modal-search-placeholder')}
            style={{
              borderBottom: '1px solid #C1BBB3',
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <div style={{ marginRight: '16px' }}>
                  <img
                    src={SearchIcon}
                    alt=""
                    style={{
                      height: '32px',
                      pointerEvents: 'none',
                      userSelect: 'none',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  />
                </div>
              ),
              endAdornment: (
                <>
                  {areApplicationsLoading ? <CircularProgress color='inherit' size={20} /> : null}
                  {searchText?.length > 0 && (
                    <IconButton onClick={() => setSearchText('')}>
                      <CloseIcon fontSize='small' />
                    </IconButton>
                  )}
                </>
              ),
            }}
            sx={{
              border: '0px 0px 1px 0px',
              backgroundColor: '#8C755D0D',
              '& .MuiInputBase-input::placeholder': {
                color: '#564C47',
                opacity: 1,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default GroupsSearch;
